import useUpdateOnMount from '@anm/hooks/useUpdateOnMount';
import React, { memo, FC } from 'react';
import { useSelector } from 'react-redux';

import { filterSelectors } from '../../../store/modules/filter';
import { templateSelectors } from '../../../store/modules/template';

import MasonryWrapper from './MasonryWrapper';
import NotFound from './NotFound/Desktop';
import TemplateItem from './TemplateItem';
import Wrapper, { GridWrapper, Title } from './Wrapper';
import { getBreakpointColumnsObj, getTemplateSize } from './helpers';
import { TemplateListProps } from './types';

export const MASONRY_ITEM_MARGIN_BOTTOM = 40;

const TemplateList: FC<TemplateListProps> = ({ title }) => {
  const masonryResetKey = useUpdateOnMount();
  const templateList = useSelector(templateSelectors.selectTemplateList);
  const templateFilterName = useSelector(templateSelectors.selectTemplateFiltersSearch);
  const filters = useSelector(filterSelectors.selectSavedFilters);
  const isPending = useSelector(templateSelectors.getTemplateItemsPending);

  if (!isPending && !templateList.length) {
    return <NotFound />;
  }

  const titleSlug = title || filters.name || templateFilterName;
  const mainTitle = `${titleSlug}`;

  return (
    <Wrapper>
      <Title level={2} {...(titleSlug && { title: mainTitle })} />
      <GridWrapper>
        <MasonryWrapper key={masonryResetKey} breakpointCols={getBreakpointColumnsObj()}>
          {templateList.map(template => (
            <TemplateItem
              key={template.templateId}
              // isFirstRenderPreview
              height={getTemplateSize(template).height + MASONRY_ITEM_MARGIN_BOTTOM}
              {...template}
            />
          ))}
        </MasonryWrapper>
      </GridWrapper>
    </Wrapper>
  );
};

export default memo(TemplateList);
